import { restClient } from '@/Core'

/** Тіло генерації (`SPEC-012` §4.4). */
export interface GenerateDocumentBody {
    /** uuid клієнта, перевізника чи заявки */
    owner: string
    number: string
    /** `YYYY-MM-DD` */
    date: string
    /** uuid юрособи-експедитора */
    legalEntity: string
    isStamp: boolean
    /** «Номер договору» — лише заявка (`SPEC-025` §3.1.1) */
    contractNumber?: string | null
    /** «Дата договору» `YYYY-MM-DD` — лише заявка */
    contractDate?: string | null
}

/**
 * `POST /services/document_types/{uuid}/generate` (`SPEC-012` §6.1).
 *
 * Відповідь — створений документ (картка документа власника). Генерація
 * синхронна, ~2 с на проді (LibreOffice); стеля конвертера на беку 25 с —
 * менша за таймаут клієнта, тож людина отримає зрозумілу помилку, а не обрив.
 */
export const GenerateDocumentTask = async (
    documentTypeUuid: string,
    body: GenerateDocumentBody
): Promise<Record<string, unknown> | null> => {
    const response = (await restClient.post(
        `/services/document_types/${encodeURIComponent(documentTypeUuid)}/generate`,
        { json: body }
    )) as unknown

    return response !== null && typeof response === 'object' ? (response as Record<string, unknown>) : null
}
